import { Button } from "semantic-ui-react";
import React, { useEffect } from "react";
import { SketchPicker } from "react-color";
import TooltipBase from "components/Tooltip/TooltipBase";

interface Props {
  value: string
  onChange: (newValue: string) => void
  onOpen?: () => void
  onClose?: () => void
  startOpen?: boolean
  trigger?: React.ReactNode
};

const colors = [
  "#46A0FA",
  "#23D2A0",
  "#B48CFA",
  "#FF005C",
  "#5BA8FF",
  "#64DDB2",
  "#89FFE1",
  "#CCADFF",
  "#FF5D7B",
  "#FFAFCC",
  "#FFEC89",
  "#FF8540",
  "#C20E4F",
  "#0562C0",
  "#FFD2E2",
  "#DDF7EB"
];

export const ColorPickerSquare = ({ value }: { value: string }) =>
  <div style={{ backgroundColor: value }} className="color-picker-square-placeholder" />;

const ColorPicker = (props: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { onChange } = props;

  const onRandom = () => {
    // Generates a random color, copilot code
    const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
    onChange(randomColor);
  };

  useEffect(() => {
    if (props.startOpen) {
      props.onOpen?.();
    }

    if (!props.value) {
      onRandom();
    }
  }, []);

  const colorPickerTrigger = props.trigger ?? <div style={{ backgroundColor: props.value }} className="color-picker-square" />;

  return <TooltipBase
    startOpen={props.startOpen}
    position="top left"
    onOpen={() => { setIsOpen(true); props.onOpen?.(); }}
    onClose={() => { setIsOpen(false); props.onClose?.(); }}
    open={isOpen}
    trigger={colorPickerTrigger}
    tooltipStyle={{ minWidth: 200 }}
  >
    <div className="padding-large">
      <SketchPicker
        // @ts-expect-error Bad typings
        className="color-picker-popup-interal"
        styles={{ color: { display: "none" } }}
        color={props.value}
        disableAlpha
        onChange={(c) => { onChange(c.hex); }}
        presetColors={colors}
      />
      <div className="flex-column gap">
        <Button
          size="small"
          fluid
          icon
          labelPosition="left"
          color="blue"
          onClick={onRandom}
        >
          <i className="icon large icon-dice" />
          Randomize
        </Button>
      </div>
    </div>
  </TooltipBase>;
};

export default ColorPicker;